export const SEE_PRICE = 'See Price'
export const SUBMIT_ORDERS = 'Submit Orders'
export const SEND_QUOTES = 'Send Quotes'
export const SEND_ESTIMATES = 'Send Estimates'